import { render, staticRenderFns } from "./treatments-view.vue?vue&type=template&id=658fb9b6&scoped=true&lang=pug"
import script from "./treatments-view.js?vue&type=script&lang=js&external"
export * from "./treatments-view.js?vue&type=script&lang=js&external"
import style0 from "./treatments-view.vue?vue&type=style&index=0&id=658fb9b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658fb9b6",
  null
  
)

export default component.exports